export class ResetarSenhaRequest {
  token: string;
  newPassword: string;
}
 